import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from '../../components';
// import './CTASection.css';

const CTASection = ({
  variant = "primary",
  className = "",
  showPattern = true
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const isPrimaryVariant = variant === "primary";
  const buttonVariant = isPrimaryVariant ? "light" : "primary";
  const bgClass = isPrimaryVariant
    ? "cta-primary"
    : "cta-secondary";

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1, transition: { duration: 0.5 } }
  };

  return (
    <section
      ref={ref}
      className={`cta-section section-padding position-relative overflow-hidden ${bgClass} ${className}`}
      aria-labelledby="cta-heading"
    >
      {showPattern && (
        <>
          <div className="cta-particles">
            {[...Array(15)].map((_, i) => (
              <div key={i} className="cta-particle" style={{
                '--size': `${Math.random() * 6 + 4}px`,
                '--x': `${Math.random() * 100}%`,
                '--y': `${Math.random() * 100}%`,
                '--delay': `${Math.random() * 2}s`,
                '--duration': `${Math.random() * 3 + 3}s`
              }} />
            ))}
          </div>
          <div className="cta-overlay" />
        </>
      )}

      <div className="cta-content position-relative">
        <div className="container">
          <motion.div
            className="row justify-content-center text-center"
            variants={container}
            initial="hidden"
            animate={isInView ? "show" : "hidden"}
          >
            <motion.div className="col-lg-10 col-xl-9" variants={item}>
              <motion.div
                className="cta-badge mb-4"
                variants={item}
              >
                Let's Get Started
              </motion.div>
              <motion.h2
                id="cta-heading"
                className="fw-bold mb-4"
                variants={item}
              >
                Ready to Transform Your Business?
              </motion.h2>
              <motion.p
                className="cta-description lead mb-0 mx-auto"
                variants={item}
              >
                Let's discuss how we can help you achieve your goals and drive sustainable growth.
              </motion.p>
              <motion.div
                className="cta-buttons d-flex flex-wrap gap-3 justify-content-center"
                variants={item}
              >
                <motion.div
                >
                  <Button
                    href="/contact"
                    variant={buttonVariant}
                    size="md"
                    className="cta-button px-4 px-lg-5 fw-medium"
                  >
                    Get Started Today
                  </Button>
                </motion.div>
                <motion.div
                >
                  <Button
                    href="/services"
                    variant={isPrimaryVariant ? "outline-light" : "outline-primary"}
                    size="md"
                    className="cta-button px-4 px-lg-5 fw-medium"
                  >
                    Explore Services
                  </Button>
                </motion.div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;